import { render, staticRenderFns } from "./Skandia.vue?vue&type=template&id=9d80d87a&scoped=true&"
import script from "./Skandia.vue?vue&type=script&lang=js&"
export * from "./Skandia.vue?vue&type=script&lang=js&"
import style0 from "./Skandia.vue?vue&type=style&index=0&id=9d80d87a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d80d87a",
  null
  
)

export default component.exports